import React from "react";
import SEO from "../../components/SEO";

const UVProtectionGuide = () => {
  return (
    <div style={{ padding: "20px", maxWidth: "900px", margin: "auto" }}>
      <SEO 
        title="Why UV Protection Sunglasses Are Important"
        description="Understand why UV protection sunglasses are essential for eye safety and long-term health."
      />

      <h1>Why UV Protection Sunglasses Are Important</h1>

      <p>
        UV rays from the sun can damage your eyes over time. 
        Wearing proper sunglasses helps protect your vision.
      </p>

      <h2>Benefits</h2>
      <ul>
        <li>Prevents eye damage</li>
        <li>Improves visibility</li>
        <li>Reduces glare</li>
      </ul>
    </div>
  );
};

export default UVProtectionGuide;